import React from "react";
import AMO from "../../assets/img/amo.png";

export const AmoCRMIcon = ({ size }) => {
  return (
    <div style={{ width: size ? size : "40px", height: size ? size : "40px" }}>
      <img style={{ width: "100%", height: "100%" }} src={AMO} alt="" />
    </div>
  );
};
